"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M16 13h-3V3h-2v10H8l4 4zM4 19v2h16v-2z"
}), 'VerticalAlignBottomSharp');